const SET_NOTIFICATION = (state, payload) => {
  state.notification = payload;
};

export default {
  SET_NOTIFICATION,
};
